import axios from "axios";

  
// Register Attendee
export const registerAttendeeNew = (userData) => {
    return axios.post("/api/attendees/add", userData);

  };
  